import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { APP_CONFIG } from '@frontend-workspace/app-config';
import { ModalKey } from '@frontend-workspace/shared/src/lib/types/modal-key';

@Component({
  selector: 'fip-support-modal',
  templateUrl: './support.modal.html',
  styleUrls: ['./support.modal.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SupportModalComponent implements OnInit {
  data = inject<{
    title: string;
  }>(MAT_DIALOG_DATA);
  private readonly _appConfig = inject(APP_CONFIG);

  readonly modalKey: ModalKey = 'support';

  private readonly router = inject(Router);

  path: string;
  appVersion: string;

  ngOnInit(): void {
    this.path = this.router.url;
    this.appVersion = this._appConfig.displayVersionNumber;
  }
}
